<script lang="ts">
	//Design system components
	import { Alert, Button, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { real_id_z } from 'src/helpers/interface_helpers';
	//Services
	import { postReq } from 'src/services/http';
	import { format } from 'svelte-i18n';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device;

	let loading = false;

	const startCalibration = async () => {
		loading = true;
		//a=call&cc=Configuration&ep=0&m=set&params=[{"parameter":25,"value":0}]

		const params = {
			id: real_id_z(device.id), //gateway's id
			a: 'call', //inclusion command
			cc: 'Configuration', //command class
			m: 'set', //method
			ep: 0, //endpoint
			params: JSON.stringify([{ parameter: 78, value: 1 }]), //parameters parameter - setting index, value - setting value
		};
		const res: SettingRequest = await postReq(`/fast/device/zw`, {
			...params,
		});

		if (res.isok) {
			params.m = 'get'; //override method
			params.params = JSON.stringify([78]); //override params
			const res_get: SettingRequest = await postReq(`/fast/device/zw`, {
				...params,
			});
		}
		await onSettingsResponse(res, device, {
			success: $format('calibration_started_scc_toast'),
		});
		loading = false;
	};

	//Todo: need to use setting 78 for visualization of calibration states (1 - started(set only), 2 - calibrated(read only), 3 - not calibrated(read only), 4 - calibration error(read only))

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: startCalibration,
				loading,
				disabled: loading,
				label: $format('button_start_calibration'),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Text styleType="body-small" class="mb-s">
	{$format('calib_shutter_description', {
		default: 'Calibration allows your shutter to have position control.',
	})}
</Text>
<Alert
	type="warning"
	isHeadingBold
	heading={$format('alert_warning_local_control_setting', {
		default: 'Attention',
	})}
	message={$format('calib_warn_description', {
		default: 'Please make sure that there are no obstacles in the way during the calibration.',
	})}
/>
{#if !$showNewLayout}
	<Button class="mt-s" {loading} size="m" width="full" on:click={startCalibration}>
		{$format('button_start_calibration')}
	</Button>
{/if}
